import _asyncToGenerator from "C:/GitLab-Runner/builds/VgMjNYji/0/billing/billingmalta/src/frontend/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import { EntityQuery } from '@cime/breeze-client';
import { AbstractBreezeViewComponent } from '@common/classes/breeze-view';
import { InvoiceStatusCodes, InvoiceTypeCodes, LanguageCodes, ServiceCodes, TaxCodes, UnitOfMeasurementCodes } from '@common/classes/codes';
import { round } from '@common/classes/math';
import { InvoicePermissions } from '@common/classes/permissions';
import { AppControlComponent } from '@common/components/app-control/app-control.component';
import { NmswChargeCandidatesModalComponent } from '@common/components/nmsw-charge-candidates-modal/nmsw-charge-candidates-modal.component';
import { UploadActionButtonsComponent } from '@common/components/upload-action-buttons.component';
import { ViewMode } from '@common/models/view-mode';
import { BreezeViewService } from '@common/services/breeze-view.service';
import { CqrsService } from '@common/services/cqrs.service';
import { RememberStateService } from '@common/services/remember-state.service';
import { UserService } from '@common/services/user.service';
import { environment } from '@environments/environment';
import { InvoiceCloneModalComponent } from '@invoice/components/invoice-clone-modal/invoice-clone-modal.component';
import { InvoiceService } from '@invoice/services/invoice.service';
import _ from 'lodash';
import { firstValueFrom } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { InvoiceStateMachine } from '../../classes/invoice.workflow';
import { InvoiceFullCreditNoteComponent } from '../invoice-full-credit-note/invoice-full-credit-note.component';
import { QrCodeModalComponent } from '../qr-code-modal/qr-code-modal.component';
import * as i0 from "@angular/core";
import * as i1 from "@common/services/breeze-view.service";
import * as i2 from "@common/services/user.service";
import * as i3 from "@common/services/cqrs.service";
import * as i4 from "@invoice/services/invoice.service";
import * as i5 from "@common/services/remember-state.service";
import * as i6 from "@angular/common";
import * as i7 from "@angular/forms";
import * as i8 from "@progress/kendo-angular-layout";
import * as i9 from "../../../common/components/action-bar/action-bar.component";
import * as i10 from "../../../common/components/app-control/app-control.component";
import * as i11 from "../../../common/components/loader/loader.component";
import * as i12 from "../../../common/components/content-header/content-header.component";
import * as i13 from "../../../common/components/note-list/note-list.component";
import * as i14 from "../../../common/components/vessel-visit-view/vessel-visit-view.component";
import * as i15 from "../../../common/components/nmsw-vessel-visit-view/nmsw-vessel-visit-view.component";
import * as i16 from "../invoice-email-recipient/invoice-email-recipient.component";
import * as i17 from "../invoice-change-list/invoice-change-list.component";
import * as i18 from "../invoice-item-list/invoice-item-list.component";
import * as i19 from "@ngx-translate/core";
import * as i20 from "@progress/kendo-angular-intl";
const _c0 = ["files"];
const _c1 = ["tabStrip"];
function InvoiceViewComponent_ng_template_1_div_26_app_nmsw_vessel_visit_view_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "app-nmsw-vessel-visit-view", 23);
  }
  if (rf & 2) {
    const ctx_r21 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("vtsVesselVisit", ctx_r21.vesselVisit);
  }
}
function InvoiceViewComponent_ng_template_1_div_26_app_vessel_visit_view_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "app-vessel-visit-view", 24);
  }
  if (rf & 2) {
    const ctx_r22 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("vesselVisit", ctx_r22.vesselVisit);
  }
}
function InvoiceViewComponent_ng_template_1_div_26_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 19)(1, "div", 20);
    i0.ɵɵtemplate(2, InvoiceViewComponent_ng_template_1_div_26_app_nmsw_vessel_visit_view_2_Template, 1, 1, "app-nmsw-vessel-visit-view", 21);
    i0.ɵɵtemplate(3, InvoiceViewComponent_ng_template_1_div_26_app_vessel_visit_view_3_Template, 1, 1, "app-vessel-visit-view", 22);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r13 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r13.model.vtsVesselVisitId && ctx_r13.vesselVisit);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r13.model.vesselVisitId && ctx_r13.vesselVisit);
  }
}
function InvoiceViewComponent_ng_template_1_ng_template_31_ng_container_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function InvoiceViewComponent_ng_template_1_ng_template_31_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, InvoiceViewComponent_ng_template_1_ng_template_31_ng_container_0_Template, 1, 0, "ng-container", 25);
  }
  if (rf & 2) {
    i0.ɵɵnextContext(2);
    const _r1 = i0.ɵɵreference(3);
    i0.ɵɵproperty("ngTemplateOutlet", _r1);
  }
}
function InvoiceViewComponent_ng_template_1_ng_template_34_ng_container_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function InvoiceViewComponent_ng_template_1_ng_template_34_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, InvoiceViewComponent_ng_template_1_ng_template_34_ng_container_0_Template, 1, 0, "ng-container", 25);
  }
  if (rf & 2) {
    i0.ɵɵnextContext(2);
    const _r3 = i0.ɵɵreference(5);
    i0.ɵɵproperty("ngTemplateOutlet", _r3);
  }
}
function InvoiceViewComponent_ng_template_1_ng_template_37_ng_container_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function InvoiceViewComponent_ng_template_1_ng_template_37_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, InvoiceViewComponent_ng_template_1_ng_template_37_ng_container_0_Template, 1, 0, "ng-container", 25);
  }
  if (rf & 2) {
    i0.ɵɵnextContext(2);
    const _r5 = i0.ɵɵreference(7);
    i0.ɵɵproperty("ngTemplateOutlet", _r5);
  }
}
function InvoiceViewComponent_ng_template_1_ng_template_40_ng_container_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function InvoiceViewComponent_ng_template_1_ng_template_40_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, InvoiceViewComponent_ng_template_1_ng_template_40_ng_container_0_Template, 1, 0, "ng-container", 25);
  }
  if (rf & 2) {
    i0.ɵɵnextContext(2);
    const _r7 = i0.ɵɵreference(9);
    i0.ɵɵproperty("ngTemplateOutlet", _r7);
  }
}
function InvoiceViewComponent_ng_template_1_ng_template_43_ng_container_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function InvoiceViewComponent_ng_template_1_ng_template_43_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, InvoiceViewComponent_ng_template_1_ng_template_43_ng_container_0_Template, 1, 0, "ng-container", 25);
  }
  if (rf & 2) {
    i0.ɵɵnextContext(2);
    const _r9 = i0.ɵɵreference(11);
    i0.ɵɵproperty("ngTemplateOutlet", _r9);
  }
}
function InvoiceViewComponent_ng_template_1_ng_template_46_ng_container_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function InvoiceViewComponent_ng_template_1_ng_template_46_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, InvoiceViewComponent_ng_template_1_ng_template_46_ng_container_0_Template, 1, 0, "ng-container", 25);
  }
  if (rf & 2) {
    i0.ɵɵnextContext(2);
    const _r11 = i0.ɵɵreference(13);
    i0.ɵɵproperty("ngTemplateOutlet", _r11);
  }
}
function InvoiceViewComponent_ng_template_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r30 = i0.ɵɵgetCurrentView();
    i0.ɵɵelement(0, "app-action-bar", 7);
    i0.ɵɵelementStart(1, "app-content-header", 8)(2, "div", 9)(3, "div", 10)(4, "table", 11)(5, "tr")(6, "td", 12);
    i0.ɵɵtext(7);
    i0.ɵɵpipe(8, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(9, "td");
    i0.ɵɵtext(10);
    i0.ɵɵpipe(11, "kendoNumber");
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(12, "tr")(13, "td", 12);
    i0.ɵɵtext(14);
    i0.ɵɵpipe(15, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(16, "td");
    i0.ɵɵtext(17);
    i0.ɵɵpipe(18, "kendoNumber");
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(19, "tr")(20, "td", 12);
    i0.ɵɵtext(21);
    i0.ɵɵpipe(22, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(23, "td");
    i0.ɵɵtext(24);
    i0.ɵɵpipe(25, "kendoNumber");
    i0.ɵɵelementEnd()()()()()();
    i0.ɵɵtemplate(26, InvoiceViewComponent_ng_template_1_div_26_Template, 4, 2, "div", 13);
    i0.ɵɵelementStart(27, "kendo-tabstrip", 14, 15);
    i0.ɵɵlistener("tabSelect", function InvoiceViewComponent_ng_template_1_Template_kendo_tabstrip_tabSelect_27_listener($event) {
      i0.ɵɵrestoreView(_r30);
      const ctx_r29 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r29.tabSelected($event));
    });
    i0.ɵɵelementStart(29, "kendo-tabstrip-tab", 16);
    i0.ɵɵpipe(30, "translate");
    i0.ɵɵtemplate(31, InvoiceViewComponent_ng_template_1_ng_template_31_Template, 1, 1, "ng-template", 17);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(32, "kendo-tabstrip-tab", 16);
    i0.ɵɵpipe(33, "translate");
    i0.ɵɵtemplate(34, InvoiceViewComponent_ng_template_1_ng_template_34_Template, 1, 1, "ng-template", 17);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(35, "kendo-tabstrip-tab", 16);
    i0.ɵɵpipe(36, "translate");
    i0.ɵɵtemplate(37, InvoiceViewComponent_ng_template_1_ng_template_37_Template, 1, 1, "ng-template", 17);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(38, "kendo-tabstrip-tab", 18);
    i0.ɵɵpipe(39, "translate");
    i0.ɵɵtemplate(40, InvoiceViewComponent_ng_template_1_ng_template_40_Template, 1, 1, "ng-template", 17);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(41, "kendo-tabstrip-tab", 16);
    i0.ɵɵpipe(42, "translate");
    i0.ɵɵtemplate(43, InvoiceViewComponent_ng_template_1_ng_template_43_Template, 1, 1, "ng-template", 17);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(44, "kendo-tabstrip-tab", 16);
    i0.ɵɵpipe(45, "translate");
    i0.ɵɵtemplate(46, InvoiceViewComponent_ng_template_1_ng_template_46_Template, 1, 1, "ng-template", 17);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("items", ctx_r0.actionBar);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("title", ctx_r0.title)("breadcrumb", ctx_r0.breadcrumb);
    i0.ɵɵadvance(6);
    i0.ɵɵtextInterpolate1("", i0.ɵɵpipeBind1(8, 26, "Amount"), ":");
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate2("", i0.ɵɵpipeBind2(11, 28, ctx_r0.model.amount, "n2"), " ", ctx_r0.model.currencyId, "");
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate1("", i0.ɵɵpipeBind1(15, 31, "Tax Amount"), ":");
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate2("", i0.ɵɵpipeBind2(18, 33, ctx_r0.model.taxAmount, "n2"), " ", ctx_r0.model.currencyId, "");
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate1("", i0.ɵɵpipeBind1(22, 36, "Total Amount"), ":");
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate2("", i0.ɵɵpipeBind2(25, 38, ctx_r0.model.totalAmount, "n2"), " ", ctx_r0.model.currencyId, "");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r0.showVesselVisit);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("title", i0.ɵɵpipeBind1(30, 41, "Company Details"))("selected", ctx_r0.activeTab === 0);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("title", i0.ɵɵpipeBind1(33, 43, "Berth") + " (" + (ctx_r0.model.berthId ? 1 : 0) + ")")("selected", ctx_r0.activeTab === 1);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("title", i0.ɵɵpipeBind1(36, 45, "Dues") + " (" + ctx_r0.model.items.length + ")")("selected", ctx_r0.activeTab === 2);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("title", i0.ɵɵpipeBind1(39, 47, "Attachments") + " (" + ctx_r0.model.attachments.length + ")")("id", "attachments")("selected", ctx_r0.activeTab === 3);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("title", i0.ɵɵpipeBind1(42, 49, "Notes") + " (" + ctx_r0.countActive(ctx_r0.model.notes) + ")")("selected", ctx_r0.activeTab === 4);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("title", i0.ɵɵpipeBind1(45, 51, "Change History"))("selected", ctx_r0.activeTab === 5);
  }
}
function InvoiceViewComponent_ng_template_2_app_control_41_Template(rf, ctx) {
  if (rf & 1) {
    const _r43 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "app-control", 59);
    i0.ɵɵlistener("ngModelChange", function InvoiceViewComponent_ng_template_2_app_control_41_Template_app_control_ngModelChange_0_listener($event) {
      i0.ɵɵrestoreView(_r43);
      const ctx_r42 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r42.model.payer.addressLine1 = $event);
    });
    i0.ɵɵpipe(1, "translate");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r31 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("label", i0.ɵɵpipeBind1(1, 4, "Address"))("isDisabled", true)("ngModel", ctx_r31.model.payer.addressLine1)("entity", ctx_r31.model.payer);
  }
}
function InvoiceViewComponent_ng_template_2_ng_template_42_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "app-control", 60);
    i0.ɵɵpipe(1, "translate");
  }
  if (rf & 2) {
    i0.ɵɵproperty("label", i0.ɵɵpipeBind1(1, 2, "Address"))("isDisabled", true);
  }
}
function InvoiceViewComponent_ng_template_2_app_control_44_Template(rf, ctx) {
  if (rf & 1) {
    const _r45 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "app-control", 61);
    i0.ɵɵlistener("ngModelChange", function InvoiceViewComponent_ng_template_2_app_control_44_Template_app_control_ngModelChange_0_listener($event) {
      i0.ɵɵrestoreView(_r45);
      const ctx_r44 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r44.model.payer.addressLine2 = $event);
    });
    i0.ɵɵpipe(1, "translate");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r34 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("label", i0.ɵɵpipeBind1(1, 4, "Street Name"))("isDisabled", true)("ngModel", ctx_r34.model.payer.addressLine2)("entity", ctx_r34.model.payer);
  }
}
function InvoiceViewComponent_ng_template_2_ng_template_45_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "app-control", 60);
    i0.ɵɵpipe(1, "translate");
  }
  if (rf & 2) {
    i0.ɵɵproperty("label", i0.ɵɵpipeBind1(1, 2, "Street Name"))("isDisabled", true);
  }
}
function InvoiceViewComponent_ng_template_2_app_control_47_Template(rf, ctx) {
  if (rf & 1) {
    const _r47 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "app-control", 62);
    i0.ɵɵlistener("ngModelChange", function InvoiceViewComponent_ng_template_2_app_control_47_Template_app_control_ngModelChange_0_listener($event) {
      i0.ɵɵrestoreView(_r47);
      const ctx_r46 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r46.model.payer.city = $event);
    });
    i0.ɵɵpipe(1, "translate");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r37 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("label", i0.ɵɵpipeBind1(1, 4, "City"))("isDisabled", true)("ngModel", ctx_r37.model.payer.city)("entity", ctx_r37.model.payer);
  }
}
function InvoiceViewComponent_ng_template_2_ng_template_48_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "app-control", 60);
    i0.ɵɵpipe(1, "translate");
  }
  if (rf & 2) {
    i0.ɵɵproperty("label", i0.ɵɵpipeBind1(1, 2, "City"))("isDisabled", true);
  }
}
function InvoiceViewComponent_ng_template_2_div_57_Template(rf, ctx) {
  if (rf & 1) {
    const _r49 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 55)(1, "app-control", 63);
    i0.ɵɵlistener("ngModelChange", function InvoiceViewComponent_ng_template_2_div_57_Template_app_control_ngModelChange_1_listener($event) {
      i0.ɵɵrestoreView(_r49);
      const ctx_r48 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r48.model.recipientData.taxNumber = $event);
    });
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r40 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("label", i0.ɵɵpipeBind1(2, 5, "Tax Number - Old"))("options", ctx_r40.recipientTaxNumbers)("isDisabled", ctx_r40.isInvoiceDisabled())("ngModel", ctx_r40.model.recipientData.taxNumber)("entity", ctx_r40.model.recipientData);
  }
}
function InvoiceViewComponent_ng_template_2_div_58_Template(rf, ctx) {
  if (rf & 1) {
    const _r51 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 55)(1, "app-control", 49);
    i0.ɵɵlistener("ngModelChange", function InvoiceViewComponent_ng_template_2_div_58_Template_app_control_ngModelChange_1_listener($event) {
      i0.ɵɵrestoreView(_r51);
      const ctx_r50 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r50.model.recipientData.taxNumber = $event);
    });
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r41 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("label", i0.ɵɵpipeBind1(2, 4, "Tax Number - Old"))("isDisabled", ctx_r41.isInvoiceDisabled())("ngModel", ctx_r41.model.recipientData.taxNumber)("entity", ctx_r41.model.recipientData);
  }
}
function InvoiceViewComponent_ng_template_2_Template(rf, ctx) {
  if (rf & 1) {
    const _r53 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 26)(1, "div", 27)(2, "app-control", 28);
    i0.ɵɵlistener("ngModelChange", function InvoiceViewComponent_ng_template_2_Template_app_control_ngModelChange_2_listener($event) {
      i0.ɵɵrestoreView(_r53);
      const ctx_r52 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r52.model.payerId = $event);
    })("ngModelChange", function InvoiceViewComponent_ng_template_2_Template_app_control_ngModelChange_2_listener($event) {
      i0.ɵɵrestoreView(_r53);
      const ctx_r54 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r54.onPayerChange($event));
    });
    i0.ɵɵpipe(3, "translate");
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(4, "div", 27)(5, "app-control", 29);
    i0.ɵɵlistener("ngModelChange", function InvoiceViewComponent_ng_template_2_Template_app_control_ngModelChange_5_listener($event) {
      i0.ɵɵrestoreView(_r53);
      const ctx_r55 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r55.model.issuedById = $event);
    });
    i0.ɵɵpipe(6, "translate");
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(7, "div", 27)(8, "app-control", 30);
    i0.ɵɵlistener("ngModelChange", function InvoiceViewComponent_ng_template_2_Template_app_control_ngModelChange_8_listener($event) {
      i0.ɵɵrestoreView(_r53);
      const ctx_r56 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r56.model.approvedById = $event);
    });
    i0.ɵɵpipe(9, "translate");
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(10, "div", 27)(11, "app-control", 31);
    i0.ɵɵlistener("ngModelChange", function InvoiceViewComponent_ng_template_2_Template_app_control_ngModelChange_11_listener($event) {
      i0.ɵɵrestoreView(_r53);
      const ctx_r57 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r57.model.createdById = $event);
    });
    i0.ɵɵpipe(12, "translate");
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(13, "div", 27)(14, "app-control", 32);
    i0.ɵɵlistener("ngModelChange", function InvoiceViewComponent_ng_template_2_Template_app_control_ngModelChange_14_listener($event) {
      i0.ɵɵrestoreView(_r53);
      const ctx_r58 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r58.model.createdDate = $event);
    });
    i0.ɵɵpipe(15, "translate");
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(16, "div", 27)(17, "app-control", 33);
    i0.ɵɵlistener("ngModelChange", function InvoiceViewComponent_ng_template_2_Template_app_control_ngModelChange_17_listener($event) {
      i0.ɵɵrestoreView(_r53);
      const ctx_r59 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r59.model.serviceDate = $event);
    });
    i0.ɵɵpipe(18, "translate");
    i0.ɵɵelementEnd()()();
    i0.ɵɵelementStart(19, "div", 26)(20, "div", 27)(21, "app-control", 34);
    i0.ɵɵlistener("ngModelChange", function InvoiceViewComponent_ng_template_2_Template_app_control_ngModelChange_21_listener($event) {
      i0.ɵɵrestoreView(_r53);
      const ctx_r60 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r60.model.customerOrderNumber = $event);
    });
    i0.ɵɵpipe(22, "translate");
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(23, "div", 27)(24, "app-control", 35);
    i0.ɵɵlistener("ngModelChange", function InvoiceViewComponent_ng_template_2_Template_app_control_ngModelChange_24_listener($event) {
      i0.ɵɵrestoreView(_r53);
      const ctx_r61 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r61.model.issuedDate = $event);
    });
    i0.ɵɵpipe(25, "translate");
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(26, "div", 27)(27, "app-control", 36);
    i0.ɵɵlistener("ngModelChange", function InvoiceViewComponent_ng_template_2_Template_app_control_ngModelChange_27_listener($event) {
      i0.ɵɵrestoreView(_r53);
      const ctx_r62 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r62.model.approvedDate = $event);
    });
    i0.ɵɵpipe(28, "translate");
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(29, "div", 27)(30, "app-control", 37);
    i0.ɵɵlistener("ngModelChange", function InvoiceViewComponent_ng_template_2_Template_app_control_ngModelChange_30_listener($event) {
      i0.ɵɵrestoreView(_r53);
      const ctx_r63 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r63.model.lastModifiedById = $event);
    });
    i0.ɵɵpipe(31, "translate");
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(32, "div", 27)(33, "app-control", 38);
    i0.ɵɵlistener("ngModelChange", function InvoiceViewComponent_ng_template_2_Template_app_control_ngModelChange_33_listener($event) {
      i0.ɵɵrestoreView(_r53);
      const ctx_r64 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r64.model.lastModifiedDate = $event);
    });
    i0.ɵɵpipe(34, "translate");
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(35, "div", 27)(36, "app-control", 39);
    i0.ɵɵlistener("ngModelChange", function InvoiceViewComponent_ng_template_2_Template_app_control_ngModelChange_36_listener($event) {
      i0.ɵɵrestoreView(_r53);
      const ctx_r65 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r65.model.archivedDate = $event);
    });
    i0.ɵɵpipe(37, "translate");
    i0.ɵɵelementEnd()()();
    i0.ɵɵelement(38, "hr");
    i0.ɵɵelementStart(39, "div", 26)(40, "div", 40);
    i0.ɵɵtemplate(41, InvoiceViewComponent_ng_template_2_app_control_41_Template, 2, 6, "app-control", 41);
    i0.ɵɵtemplate(42, InvoiceViewComponent_ng_template_2_ng_template_42_Template, 2, 4, "ng-template", null, 42, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵtemplate(44, InvoiceViewComponent_ng_template_2_app_control_44_Template, 2, 6, "app-control", 43);
    i0.ɵɵtemplate(45, InvoiceViewComponent_ng_template_2_ng_template_45_Template, 2, 4, "ng-template", null, 44, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵtemplate(47, InvoiceViewComponent_ng_template_2_app_control_47_Template, 2, 6, "app-control", 45);
    i0.ɵɵtemplate(48, InvoiceViewComponent_ng_template_2_ng_template_48_Template, 2, 4, "ng-template", null, 46, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(50, "div", 27)(51, "app-control", 47);
    i0.ɵɵlistener("ngModelChange", function InvoiceViewComponent_ng_template_2_Template_app_control_ngModelChange_51_listener($event) {
      i0.ɵɵrestoreView(_r53);
      const ctx_r66 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r66.model.recipientData.postOfficeId = $event);
    });
    i0.ɵɵpipe(52, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(53, "app-control", 48);
    i0.ɵɵlistener("ngModelChange", function InvoiceViewComponent_ng_template_2_Template_app_control_ngModelChange_53_listener($event) {
      i0.ɵɵrestoreView(_r53);
      const ctx_r67 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r67.model.recipientData.countryId = $event);
    });
    i0.ɵɵpipe(54, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(55, "app-control", 49);
    i0.ɵɵlistener("ngModelChange", function InvoiceViewComponent_ng_template_2_Template_app_control_ngModelChange_55_listener($event) {
      i0.ɵɵrestoreView(_r53);
      const ctx_r68 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r68.model.recipientData.taxNumber = $event);
    });
    i0.ɵɵpipe(56, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(57, InvoiceViewComponent_ng_template_2_div_57_Template, 3, 7, "div", 50);
    i0.ɵɵtemplate(58, InvoiceViewComponent_ng_template_2_div_58_Template, 3, 6, "div", 50);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(59, "div", 27)(60, "app-control", 51);
    i0.ɵɵlistener("ngModelChange", function InvoiceViewComponent_ng_template_2_Template_app_control_ngModelChange_60_listener($event) {
      i0.ɵɵrestoreView(_r53);
      const ctx_r69 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r69.model.statusId = $event);
    });
    i0.ɵɵpipe(61, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(62, "app-control", 52);
    i0.ɵɵlistener("ngModelChange", function InvoiceViewComponent_ng_template_2_Template_app_control_ngModelChange_62_listener($event) {
      i0.ɵɵrestoreView(_r53);
      const ctx_r70 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r70.model.typeId = $event);
    });
    i0.ɵɵpipe(63, "translate");
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(64, "div", 27)(65, "app-control", 53);
    i0.ɵɵlistener("ngModelChange", function InvoiceViewComponent_ng_template_2_Template_app_control_ngModelChange_65_listener($event) {
      i0.ɵɵrestoreView(_r53);
      const ctx_r71 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r71.model.invoiceNumber = $event);
    });
    i0.ɵɵpipe(66, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(67, "app-control", 54);
    i0.ɵɵlistener("ngModelChange", function InvoiceViewComponent_ng_template_2_Template_app_control_ngModelChange_67_listener($event) {
      i0.ɵɵrestoreView(_r53);
      const ctx_r72 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r72.model.linkedInvoiceId = $event);
    });
    i0.ɵɵpipe(68, "translate");
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(69, "div", 55)(70, "div", 56)(71, "app-control", 57);
    i0.ɵɵlistener("ngModelChange", function InvoiceViewComponent_ng_template_2_Template_app_control_ngModelChange_71_listener($event) {
      i0.ɵɵrestoreView(_r53);
      const ctx_r73 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r73.model.electronicInvoice = $event);
    });
    i0.ɵɵpipe(72, "translate");
    i0.ɵɵelementEnd()();
    i0.ɵɵelement(73, "app-invoice-email-recipient", 58);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const _r32 = i0.ɵɵreference(43);
    const _r35 = i0.ɵɵreference(46);
    const _r38 = i0.ɵɵreference(49);
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("label", i0.ɵɵpipeBind1(3, 96, "Agent/Company Details"))("ngModel", ctx_r2.model.payerId)("entity", ctx_r2.model);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("label", i0.ɵɵpipeBind1(6, 98, "Issued By"))("isDisabled", true)("ngModel", ctx_r2.model.issuedById)("entity", ctx_r2.model);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("label", i0.ɵɵpipeBind1(9, 100, "Approved By"))("isDisabled", true)("ngModel", ctx_r2.model.approvedById)("entity", ctx_r2.model);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("label", i0.ɵɵpipeBind1(12, 102, "Created By"))("isDisabled", true)("ngModel", ctx_r2.model.createdById)("entity", ctx_r2.model);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("label", i0.ɵɵpipeBind1(15, 104, "Created Date"))("time", true)("isDisabled", true)("ngModel", ctx_r2.model.createdDate)("entity", ctx_r2.model);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("label", i0.ɵɵpipeBind1(18, 106, "Service Date"))("time", true)("isDisabled", ctx_r2.isInvoiceDisabled())("ngModel", ctx_r2.model.serviceDate)("entity", ctx_r2.model);
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("label", i0.ɵɵpipeBind1(22, 108, "Customer Reference"))("isDisabled", ctx_r2.isInvoiceDisabled())("ngModel", ctx_r2.model.customerOrderNumber)("entity", ctx_r2.model);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("label", i0.ɵɵpipeBind1(25, 110, "Issued Date"))("time", true)("isDisabled", true)("ngModel", ctx_r2.model.issuedDate)("entity", ctx_r2.model);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("label", i0.ɵɵpipeBind1(28, 112, "Approved Date"))("time", true)("isDisabled", true)("ngModel", ctx_r2.model.approvedDate)("entity", ctx_r2.model);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("label", i0.ɵɵpipeBind1(31, 114, "Modified By"))("isDisabled", true)("ngModel", ctx_r2.model.lastModifiedById)("entity", ctx_r2.model);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("label", i0.ɵɵpipeBind1(34, 116, "Modified Date"))("time", true)("isDisabled", true)("ngModel", ctx_r2.model.lastModifiedDate)("entity", ctx_r2.model);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("label", i0.ɵɵpipeBind1(37, 118, "Archived Date"))("time", true)("isDisabled", true)("ngModel", ctx_r2.model.archivedDate)("entity", ctx_r2.model);
    i0.ɵɵadvance(5);
    i0.ɵɵproperty("ngIf", ctx_r2.model.payer)("ngIfElse", _r32);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngIf", ctx_r2.model.payer)("ngIfElse", _r35);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngIf", ctx_r2.model.payer)("ngIfElse", _r38);
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("label", i0.ɵɵpipeBind1(52, 120, "Postcode"))("isDisabled", true)("ngModel", ctx_r2.model.recipientData.postOfficeId)("entity", ctx_r2.model.recipientData);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("label", i0.ɵɵpipeBind1(54, 122, "Country"))("isDisabled", ctx_r2.isInvoiceDisabled())("ngModel", ctx_r2.model.recipientData.countryId)("entity", ctx_r2.model.recipientData);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("label", i0.ɵɵpipeBind1(56, 124, "VAT Number"))("isDisabled", ctx_r2.isInvoiceDisabled())("ngModel", ctx_r2.model.recipientData.taxNumber)("entity", ctx_r2.model.recipientData);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", !ctx_r2.isTaxNumberCodeList());
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !ctx_r2.isTaxNumberCodeList());
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("label", i0.ɵɵpipeBind1(61, 126, "Status"))("isDisabled", true)("ngModel", ctx_r2.model.statusId)("entity", ctx_r2.model);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("label", i0.ɵɵpipeBind1(63, 128, "Type"))("isDisabled", true)("ngModel", ctx_r2.model.typeId)("entity", ctx_r2.model);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("label", i0.ɵɵpipeBind1(66, 130, "Invoice Number"))("isDisabled", true)("ngModel", ctx_r2.model.invoiceNumber)("entity", ctx_r2.model);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("label", i0.ɵɵpipeBind1(68, 132, "Link To Invoice"))("selectLabel", ctx_r2.linkedInvoiceLabel)("isDisabled", !ctx_r2.breezeViewService.isEditMode())("ngModel", ctx_r2.model.linkedInvoiceId)("entity", ctx_r2.model);
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("label", i0.ɵɵpipeBind1(72, 134, "e-Invoice"))("isDisabled", ctx_r2.isInvoiceDisabled())("ngModel", ctx_r2.model.electronicInvoice)("entity", ctx_r2.model);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("items", ctx_r2.model.emailRecipients)("isDisabled", ctx_r2.isInvoiceDisabled());
  }
}
function InvoiceViewComponent_ng_template_4_Template(rf, ctx) {
  if (rf & 1) {
    const _r75 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 64)(1, "div", 27)(2, "app-control", 65);
    i0.ɵɵlistener("ngModelChange", function InvoiceViewComponent_ng_template_4_Template_app_control_ngModelChange_2_listener($event) {
      i0.ɵɵrestoreView(_r75);
      const ctx_r74 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r74.model.berthId = $event);
    });
    i0.ɵɵpipe(3, "translate");
    i0.ɵɵelementEnd()()();
  }
  if (rf & 2) {
    const ctx_r4 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("label", i0.ɵɵpipeBind1(3, 6, "Berth"))("fetch", ctx_r4.fetchBerths)("fetchOnOpen", true)("isDisabled", !ctx_r4.editMode || ctx_r4.limitedEditMode)("ngModel", ctx_r4.model.berthId)("entity", ctx_r4.model);
  }
}
function InvoiceViewComponent_ng_template_6_Template(rf, ctx) {
  if (rf & 1) {
    const _r77 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 26)(1, "div", 55)(2, "app-invoice-item-list", 66);
    i0.ɵɵlistener("totalsUpdated", function InvoiceViewComponent_ng_template_6_Template_app_invoice_item_list_totalsUpdated_2_listener($event) {
      i0.ɵɵrestoreView(_r77);
      const ctx_r76 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r76.updateTotals($event));
    });
    i0.ɵɵelementEnd()()();
  }
  if (rf & 2) {
    const ctx_r6 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("items", ctx_r6.model.items)("automatic", ctx_r6.model.automatic)("isCreditNote", ctx_r6.isCreditNote)("editMode", ctx_r6.editMode && !ctx_r6.limitedEditMode);
  }
}
function InvoiceViewComponent_ng_template_8_Template(rf, ctx) {
  if (rf & 1) {
    const _r80 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 26)(1, "div", 55)(2, "app-control", 67, 68);
    i0.ɵɵlistener("ngModelChange", function InvoiceViewComponent_ng_template_8_Template_app_control_ngModelChange_2_listener($event) {
      i0.ɵɵrestoreView(_r80);
      const ctx_r79 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r79.model.attachments = $event);
    })("addFile", function InvoiceViewComponent_ng_template_8_Template_app_control_addFile_2_listener($event) {
      i0.ɵɵrestoreView(_r80);
      const ctx_r81 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r81.onAddFile($event));
    });
    i0.ɵɵelementEnd()()();
  }
  if (rf & 2) {
    const ctx_r8 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("multi", true)("editMode", ctx_r8.editMode)("isInternalDisabled", ctx_r8.isInternalDisabled())("allowToEditFile", ctx_r8.allowToEditFile)("allowToDeleteFile", ctx_r8.allowToDeleteFile)("ngModel", ctx_r8.model.attachments)("entity", ctx_r8.model);
  }
}
function InvoiceViewComponent_ng_template_10_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "app-note-list", 69);
  }
  if (rf & 2) {
    const ctx_r10 = i0.ɵɵnextContext();
    i0.ɵɵproperty("items", ctx_r10.model.notes)("editMode", ctx_r10.editMode);
  }
}
function InvoiceViewComponent_ng_template_12_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "app-invoice-change-list", 70);
  }
  if (rf & 2) {
    const ctx_r12 = i0.ɵɵnextContext();
    i0.ɵɵproperty("invoiceId", ctx_r12.model.id);
  }
}
export class InvoiceViewComponent extends AbstractBreezeViewComponent {
  get title() {
    if (this.isNew) {
      return this.translateService.instant('New Invoice');
    }
    const invoiceType = this.model.typeId;
    const invoiceStatus = ` | ${this.model.statusId}`;
    const invoiceNumber = ` | ${this.model.invoiceNumber ? this.model.invoiceNumber : this.model.internalInvoiceNumber}`;
    const recipientName = this.model.recipientData?.name1 === null ? '' : ` | ${this.model.recipientData?.name1}`;
    return `${invoiceType}${invoiceStatus}${invoiceNumber}${recipientName}`;
  }
  get status() {
    return this.model.statusId;
  }
  get items() {
    return _.sortBy(this.model.items, x => x.sequenceNumber);
  }
  constructor(breezeViewService, userService, cqrs, invoiceService, rememberStateService) {
    var _this;
    super(breezeViewService);
    _this = this;
    this.userService = userService;
    this.cqrs = cqrs;
    this.invoiceService = invoiceService;
    this.rememberStateService = rememberStateService;
    this.entityName = 'Invoice';
    this.parentRoute = 'invoice';
    this.createPermission = InvoicePermissions.Action.create;
    this.editPermission = InvoicePermissions.Action.edit;
    this.showVesselVisit = false;
    this.isCreditNote = false;
    this.limitedEditMode = false;
    this.payerTaxNumbers = [];
    this.recipientTaxNumbers = [];
    this.deleteOptions = {
      related: []
    };
    this.tag = {};
    this.isBusy = true;
    this.breadcrumb = [{
      icon: 'list',
      title: this.translateService.get('Invoices'),
      route: '/invoice/list'
    }, {
      icon: 'edit',
      title: this.translateService.get('Invoice')
    }];
    this.fetchBerths = /*#__PURE__*/function () {
      var _ref = _asyncToGenerator(function* (berthId) {
        const query = new EntityQuery('VisitBerths').withParameters({
          $method: 'POST',
          $data: {
            vtsVesselVisitId: _this.model.vtsVesselVisitId,
            filter: berthId
          }
        });
        const data = yield _this.breezeViewService.entityManager.executeQuery(query);
        return data.results.map(x => ({
          value: x.id,
          label: x.name
        }));
      });
      return function (_x) {
        return _ref.apply(this, arguments);
      };
    }();
    this.isInternalDisabled = () => _.includes([InvoiceStatusCodes.Closed, InvoiceStatusCodes.Approved], this.model.statusId);
    this.allowToEditFile = file => this.model.statusId === InvoiceStatusCodes.Draft || this.model.typeId === InvoiceTypeCodes.FullCreditNote && this.model.statusId === InvoiceStatusCodes.WaitingForApproval || file.id < 0;
    this.allowToDeleteFile = file => {
      if (_.includes([InvoiceStatusCodes.Approved, InvoiceStatusCodes.Closed], this.model.statusId) && !file.internal) {
        this.dialogService.warning(this.translateService.instant('Error'), this.translateService.instant(`Can not delete a non internal file`)).then(result => {});
      }
      if (_.includes([InvoiceStatusCodes.Issued, InvoiceStatusCodes.Draft], this.model.statusId)) {
        return true;
      }
      if (_.includes([InvoiceStatusCodes.Approved, InvoiceStatusCodes.Closed], this.model.statusId) && file.internal) {
        return true;
      }
      return file.id < 0;
    };
    if (this.mode === ViewMode.create) this.rememberedRoute = history.state.data?.route;
  }
  ngOnInit() {
    this.addButtons();
    this.breezeViewService.activatedRoute.params.pipe(takeUntil(this.destroy$)).subscribe(params => {
      this.id = params.id;
      if (this.id) {
        return this.fetch();
      }
    });
    this.entityChangedSubscription = this.entityManager.entityChanged.subscribe(changeArgs => {
      const entity = changeArgs.entity;
      const action = changeArgs.entityAction;
      if (this.model === entity || entity.entityType.namespace.indexOf(this.model.entityType.namespace) !== 0) {
        return;
      }
    });
    super.initialize();
  }
  ngOnDestroy() {
    this.entityManager.entityChanged.unsubscribe(this.entityChangedSubscription);
    super.ngOnDestroy();
  }
  modelLoaded() {
    super.modelLoaded();
    if (this.mode === ViewMode.create) {
      if (['vesselVisitCreateInvoice', 'vtsVesselVisitCreateInvoice'].includes(history.state.data?.action)) {
        if (history.state.data?.action === 'vesselVisitCreateInvoice') this.addVesselVisitItemsToInvoice();
        if (history.state.data?.action === 'vtsVesselVisitCreateInvoice') this.model.vtsVesselVisitId = history.state.data?.vesselVisitId;
        this.onPayerChange(history.state.data?.customerId);
        this.model.voyageNumber = history.state.data?.voyageNumber;
        this.model.ata = history.state.data?.ata;
        this.model.vesselId = history.state.data?.vesselId;
        this.model.vesselRevisionId = history.state.data?.vesselRevisionId;
        this.model.berthId = history.state.data?.berthId;
      }
    }
    if (['vesselVisitCreateInvoice', 'vtsVesselVisitCreateInvoice', 'vtsVesselVisitCreateAutoInvoice'].includes(history.state.data?.action)) {
      // Open dues tab
      this.activeTab = 2;
    }
    this.limitedEditMode = [InvoiceStatusCodes.WaitingForApproval, InvoiceStatusCodes.Approved, InvoiceStatusCodes.Closed].includes(this.model.statusId);
    this.isCreditNote = this.model.typeId === InvoiceTypeCodes.FullCreditNote;
    this.showVesselVisit = (this.model.vesselVisitId || this.model.vtsVesselVisitId) && this.rememberStateService.initialize('vesselVisitCard');
    this.loadVesselVisit();
    setTimeout(() => {
      if (this.limitedEditMode) super.disableAppControls(this.appControls);
    });
  }
  cancelEdit() {
    if (this.rememberedRoute) {
      // Disregard query parameters
      this.router.navigate([this.rememberedRoute.split('?')[0]], {
        queryParams: {},
        replaceUrl: true
      });
    } else {
      super.cancelEdit();
    }
  }
  loadVesselVisit() {
    var _this2 = this;
    return _asyncToGenerator(function* () {
      const entityName = !!_this2.model?.vesselVisitId ? 'VesselVisit' : 'VtsVesselVisit';
      const id = _this2.model.vesselVisitId || _this2.model.vtsVesselVisitId;
      const query = EntityQuery.from(entityName).withParameters({
        id
      });
      if (entityName && id) yield _this2.entityManager.executeQuery(query).then(response => _this2.vesselVisit = response.results[0]);
    })();
  }
  createEntity() {
    var _this3 = this;
    return _asyncToGenerator(function* () {
      if (history.state.data?.action === 'cloneNote') return yield _this3.cloneInvoice('CreateInvoiceCreditNote');
      if (history.state.data?.action === 'cloneInvoice') return yield _this3.cloneInvoice('CloneInvoice');
      const entity = _this3.entityManager.createEntity(_this3.entityName, {
        ...environment.settings.newInvoice(),
        createdById: _this3.userService.currentUserSubject.getValue().id,
        languageId: LanguageCodes.English,
        createInvoiceAttachment: false
      });
      const vesselVisitId = history.state.data?.invoiceVesselVisitId;
      if (_.isNumber(vesselVisitId)) {
        const [vesselVisit] = yield _this3.breezeViewService.handleQuery('VesselVisit', {
          id: vesselVisitId
        });
        entity.voyageNumber = vesselVisit.voyageNumber;
        entity.payerId = vesselVisit.primaryAgent.customerId;
      }
      _this3.stateMachine = new InvoiceStateMachine(entity);
      _this3.isBusy = false;
      return entity;
    })();
  }
  openCloneConfirmationModal() {
    const {
      result
    } = this.modalService.open(InvoiceCloneModalComponent);
    return result;
  }
  createItem(itemType, data = {}) {
    delete data._$eref;
    const item = this.entityManager.createEntity(itemType, {
      ...data,
      active: true,
      sequenceNumber: (_.max(_.map(this.model.items, x => x.sequenceNumber)) || 0) + 1
    });
    this.model.items.push(item);
    return item;
  }
  removeItem(item) {
    item.entityAspect.setDeleted();
  }
  trackByFn(index, item) {
    return item.id;
  }
  onRecipientChange(id) {
    var _this4 = this;
    return _asyncToGenerator(function* () {
      _this4.model.electronicInvoice = false;
      if (!_.isNumber(id)) {
        _this4.resetEmails();
        _this4.model.recipientData.taxNumber = null;
        _this4.resetRecipientTaxNumbers([]);
        return;
      }
      const query = new EntityQuery('Customer').withParameters({
        $method: 'POST',
        $data: {
          id
        }
      });
      let {
        results
      } = yield _this4.breezeViewService.entityManager.executeQuery(query);
      if (!_this4.model.recipient || !_this4.model.recipientData) {
        return;
      }
      const properties = _this4.model.recipientData.complexType.getProperties().map(x => x.name);
      const recipient = _.first(results);
      _.forEach(properties, property => {
        _this4.model.recipientData[property] = _this4.model.recipient[property];
      });
      _this4.model.electronicInvoice = recipient.electronicInvoicing;
      _this4.resetEmails();
      _this4.resetRecipientTaxNumbers(recipient.taxNumbers);
      _this4.model.recipientData.taxNumber = _.first(_this4.recipientTaxNumbers)?.value;
      _this4.model.customerId = _this4.model.customerId || recipient.id;
      const invoicePayerQuery = new EntityQuery('InvoicePayers').withParameters({
        $method: 'POST',
        $data: {
          recipientId: id
        }
      });
      results = (yield _this4.breezeViewService.entityManager.executeQuery(invoicePayerQuery)).results;
      const payerId = results[0]?.payerId;
      _this4.model.payerId = payerId || id;
      _this4.onPayerChange(_this4.model.payerId);
    })();
  }
  onPayerChange(id) {
    var _this5 = this;
    return _asyncToGenerator(function* () {
      ['payerTaxNumber', 'finalCustomerId', 'customerId', 'recipientId', 'recipientData.name1', 'recipientData.addressLine1', 'recipientData.addressLine2', 'recipientData.postOfficeId', 'recipientData.countryId', 'recipientData.taxNumber'].forEach(prop => _.set(_this5.model, prop, null));
      if (!_.isNumber(id)) {
        _this5.resetEmails();
        return _this5.resetPayerTaxNumbers([]);
      }
      const {
        results: {
          0: payer
        }
      } = yield _this5.breezeViewService.entityManager.executeQuery(new EntityQuery('Customer').withParameters({
        $method: 'POST',
        $data: {
          id
        }
      }));
      ['payerId', 'finalCustomerId', 'customerId', 'recipientId'].forEach(prop => _this5.model[prop] = payer.id);
      ['name1', 'addressLine1', 'addressLine2', 'postOfficeId', 'countryId'].forEach(prop => _this5.model.recipientData[prop] = payer[prop]);
      _this5.model.recipientData.taxNumber = payer.taxNumbers[0]?.taxNumber;
      _this5.resetPayerTaxNumbers(payer.taxNumbers);
      _this5.model.payerTaxNumber = _.first(_this5.payerTaxNumbers)?.value;
      _this5.resetEmails();
    })();
  }
  resetEmails() {
    _.clone(this.model.emailRecipients).forEach(email => email.entityAspect.setDeleted());
    const emails = this.model.recipient?.emails || this.model.payer?.emails || [];
    emails.forEach(email => {
      this.model.emailRecipients.push(this.model.entityAspect.entityManager.createEntity('InvoiceEmailRecipient', {
        email: email.email
      }));
    });
  }
  resetPayerTaxNumbers(taxNumbers) {
    const payerTaxNumbers = taxNumbers.map(x => ({
      value: x.taxNumber,
      label: x.taxNumber
    }));
    if (this.model.payerTaxNumber && !_.find(taxNumbers, x => x.taxNumber === this.model.payerTaxNumber)) {
      payerTaxNumbers.push({
        value: this.model.payerTaxNumber,
        label: this.model.payerTaxNumber
      });
    }
    this.payerTaxNumbers = payerTaxNumbers;
  }
  resetRecipientTaxNumbers(taxNumbers) {
    const recipientTaxNumbers = taxNumbers.map(x => ({
      value: x.taxNumber,
      label: x.taxNumber
    }));
    if (this.model.recipientData.taxNumber && !_.find(taxNumbers, x => x.taxNumber === this.model.recipientData.taxNumber)) {
      recipientTaxNumbers.push({
        value: this.model.recipientData.taxNumber,
        label: this.model.recipientData.taxNumber
      });
    }
    this.recipientTaxNumbers = recipientTaxNumbers;
  }
  fetch() {
    var _superprop_getFetch = () => super.fetch,
      _this6 = this;
    return _asyncToGenerator(function* () {
      const invoice = yield _superprop_getFetch().call(_this6);
      _this6.stateMachine = new InvoiceStateMachine(invoice);
      _this6.resetPayerTaxNumbers(invoice.payer?.taxNumbers || []);
      _this6.resetRecipientTaxNumbers(invoice.recipient?.taxNumbers || []);
      if (history.state.data?.action === 'vesselVisitAddExistingInvoice') {
        _this6.addVesselVisitItemsToInvoice();
        _this6.activeTab = 2;
      }
      if (_this6.editMode && !_this6.isEditModeAllowed()) {
        _this6.toastrService.error(_this6.translateService.instant('Can not edit invoice'));
        _this6.router.navigate([`${_this6.parentRoute}/view/${_this6.model.id}`]).then(x => invoice);
      }
      return invoice;
    })();
  }
  getTag() {
    this.tag.deleteOptions = this.deleteOptions;
    return this.tag;
  }
  delete() {
    var _this7 = this;
    return _asyncToGenerator(function* () {
      const result = yield _this7.dialogService.confirm(_this7.translateService.instant('Delete Invoice'), _this7.translateService.instant('Are you sure you want to delete invoice?'));
      if (result !== true) return;
      _this7.breezeViewService.handleCommand('invoices/delete', {
        ids: [_this7.model.id]
      }).catch(err => _this7.handleError(err)).finally(() => _this7.fetch());
    })();
  }
  issue() {
    var _superprop_getExecuteAndHandle = () => super.executeAndHandle,
      _this8 = this;
    return _asyncToGenerator(function* () {
      const serviceDate = _this8.model?.serviceDate;
      const result = yield _this8.invoiceService.invoiceIssueDate({
        title: _this8.translateService.instant('Issue Date'),
        date: new Date(),
        organizationCode: _this8.model.organizationUnit?.organization?.code,
        invoice: _this8.model
      });
      if (!result) return;
      const oldRedirectTo = _this8.redirectTo; // TIP: workaround else fetch does not work, and we dont refresh internalNumber
      if (serviceDate !== result.serviceDate) {
        _this8.redirectTo = ViewMode.view;
        yield _this8.saveChanges();
      }
      yield _superprop_getExecuteAndHandle().call(_this8, 'invoices/issue', 'Issue', {
        ids: [_this8.model.id],
        issueDate: result.date
      }).then(() => _this8.redirectTo = oldRedirectTo);
    })();
  }
  afterSave() {
    this.resetPayerTaxNumbers(this.model.payer?.taxNumbers || []);
    return super.afterSave();
  }
  lock() {
    return this.command('lock', false, this.translateService.instant('Invoice successfully locked'));
  }
  createFullCreditNote() {
    var _this9 = this;
    return _asyncToGenerator(function* () {
      const result = yield _this9.dialogService.component(InvoiceFullCreditNoteComponent, {
        width: 420
      }, {
        invoice: _this9.model
      });
      if (result.serviceDate) {
        _this9.baseCloneNavigate('cloneNote', result);
      }
    })();
  }
  command(command, redirectToList = false, successMessage = null, errorMessage = null, data = {}) {
    var _this10 = this;
    return _asyncToGenerator(function* () {
      _this10.isBusy = true;
      try {
        const response = yield firstValueFrom(_this10.cqrs.command(`invoice/${command}`, {
          ...data,
          id: _this10.model.id
        }));
        _this10.isBusy = false;
        _this10.toastrService.success(successMessage || _this10.translateService.instant('Action successful'));
        return yield redirectToList ? _this10.router.navigate([`${_this10.parentRoute}/list`]).then(() => response) : _this10.fetch().then(() => response);
      } finally {
        _this10.isBusy = false;
      }
    })();
  }
  updateTotals(total) {
    const roundTo = environment.settings.roundingSettings.taxAmount;
    this.model.amount = round(total.amount, roundTo);
    this.model.taxAmount = round(total.taxAmount, environment.settings.roundingSettings.taxAmount);
    this.model.totalAmount = round(total.totalAmount, roundTo);
  }
  addButtons() {
    this.actionBar[0].items.push({
      label: this.translateService.instant('Clone'),
      icon: 'clone',
      isVisible: () => this.viewMode,
      isDisabled: () => this.model.typeId === InvoiceTypeCodes.FullCreditNote,
      onClick: () => {
        this.openCloneConfirmationModal().then(cloneParams => this.baseCloneNavigate('cloneInvoice', cloneParams)).catch(x => {});
      }
    });
    this.actionBar.push({
      label: this.translateService.instant('Workflow'),
      isVisible: () => this.viewMode,
      items: [{
        label: () => this.translateService.instant('Delete'),
        icon: 'trash',
        isDisabled: () => !this.stateMachine.canDelete(),
        onClick: () => this.delete(),
        permissions: [InvoicePermissions.Action.delete]
      }, {
        label: this.translateService.instant('Issue'),
        icon: 'paper-plane',
        isDisabled: () => !this.stateMachine.canIssue(),
        onClick: () => this.issue(),
        permissions: [InvoicePermissions.Action.issue]
      }, {
        label: this.translateService.instant('To Approval'),
        icon: 'pen',
        isDisabled: () => !this.stateMachine.canSendToApproval(),
        onClick: () => super.executeAndHandle('invoices/approval', 'Send to Approval', {}, true),
        permissions: [InvoicePermissions.Action.waitingForApproval]
      }, {
        label: this.translateService.instant('Approve'),
        icon: 'check',
        isDisabled: () => !this.stateMachine.canApprove(),
        onClick: () => super.executeAndHandle('invoices/approve', 'Approve', {}, true),
        permissions: [InvoicePermissions.Menu.approveInvoice]
      }, {
        label: this.translateService.instant('Reject'),
        icon: 'window-close',
        isDisabled: () => !this.stateMachine.canReject(),
        onClick: () => super.executeAndHandle('invoices/reject', 'Reject'),
        permissions: [InvoicePermissions.Action.reject]
      }, {
        label: this.translateService.instant('Send To Archive'),
        icon: 'archive',
        isDisabled: () => !this.stateMachine.canArchive(),
        onClick: () => super.executeAndHandle('invoices/archive', 'Archive'),
        permissions: [InvoicePermissions.Action.archive]
      },
      // {
      //     label: this.translateService.instant('Lock'),
      //     icon: 'lock',
      //     isVisible: () => this.stateMachine.canLock(),
      //     onClick: () => this.lock(),
      //     permissions: [InvoicePermissions.Action.lock]
      // },
      {
        label: this.translateService.instant('Full Credit Note'),
        icon: 'minus-circle',
        isDisabled: () => !this.stateMachine.canCreateFullCreditNote(),
        onClick: () => this.createFullCreditNote(),
        permissions: [InvoicePermissions.Action.fullCreditNote]
      }, {
        label: () => this.translateService.instant('Add Charge Candidates'),
        icon: 'cash-register',
        isVisible: () => this.model.automatic,
        isDisabled: () => this.model.statusId !== InvoiceStatusCodes.Draft || this.model.typeId === InvoiceTypeCodes.FullCreditNote,
        onClick: () => this.addChargeCandidates()
      }]
    });
    this.actionBar.push({
      label: this.translateService.instant('Payment'),
      items: [{
        label: () => this.translateService.instant('Invoice Pdf'),
        icon: 'file-pdf',
        isVisible: () => !this.createMode,
        onClick: () => this.breezeViewService.handleCommand('CreateInvoicePdf', {
          invoiceId: this.model.id
        }).then(result => UploadActionButtonsComponent.preview(`Invoice_${this.model.invoiceNumber ? this.model.invoiceNumber.replace('/', '-') : `${this.model.statusId}_${this.model.internalInvoiceNumber}`}.pdf`, result.$value))
      }, {
        label: () => this.translateService.instant('QR Code'),
        icon: 'qrcode',
        isVisible: () => !this.createMode,
        onClick: () => {
          this.breezeViewService.openModal(QrCodeModalComponent, {
            centered: true,
            windowClass: 'qr-modal'
          });
        }
      }]
    });
    this.actionBar.push({
      label: this.translateService.instant('Vessel visit'),
      items: [{
        label: () => this.translateService.instant(`${this.showVesselVisit ? 'Hide' : 'Show'} Vessel Visit Card`),
        icon: 'ship',
        isDisabled: () => this.model.vesselVisitId === null && this.model.vtsVesselVisitId === null,
        onClick: () => {
          this.showVesselVisit = !this.showVesselVisit;
          this.rememberStateService.setState('vesselVisitCard', this.showVesselVisit);
        }
      }, {
        label: () => this.translateService.instant('Go To Vessel Visit'),
        icon: 'left-long',
        isDisabled: () => this.model.vesselVisitId === null && this.model.vtsVesselVisitId === null,
        onClick: () => {
          this.router.navigate([this.model.vesselVisitId ? `/vessel-visit/view/${this.model.vesselVisitId}` : `/msw-vessel-visit/view/${this.model.vtsVesselVisitId}`]);
        }
      }]
    });
    this.setButtonPermissions();
  }
  isInvoiceDisabled() {
    return this.viewMode || !_.includes([InvoiceStatusCodes.Draft], this.model?.statusId);
  }
  isInvoiceItemDisabled(vesselVisitServiceId) {
    return vesselVisitServiceId !== null;
  }
  isEditModeAllowed() {
    if (![InvoiceStatusCodes.Deleted, InvoiceStatusCodes.Rejected].includes(this.model.statusId)) return true;
    return false;
  }
  setButtonPermissions() {
    // Hide Actions group on deleted invoices
    const editIsVisible = this.editActionButton.isVisible;
    const editIsDisabled = this.editActionButton.isDisabled;
    this.editActionButton.isVisible = () => editIsVisible() && this.model?.statusId !== InvoiceStatusCodes.Rejected && this.model?.statusId !== InvoiceStatusCodes.Deleted;
    this.editActionButton.isDisabled = () => {
      if (editIsDisabled()) return true;
      return !this.isEditModeAllowed();
    };
    const actionGroupIsVisible = this.editActionBarGroup.isVisible;
    this.editActionBarGroup.isVisible = () => !_.isFunction(actionGroupIsVisible) || actionGroupIsVisible();
    const saveAction = this.saveActionButton.onClick;
    this.saveActionButton.onClick = () => {
      if (_.isEmpty(this.items) && this.isValid()) {
        this.tabStrip.selectTab(2);
      }
      return saveAction();
    };
  }
  beforeSave(entities) {
    super.beforeSave(entities);
    if (!this.model.payerId) {
      this.model.payerId = this.model.recipientId;
      this.model.payerTaxNumber = this.model.recipientData.taxNumber;
    }
    if (this.model.recipient?.code === '0' && this.model.recipientData.taxNumber) {
      this.model.payerTaxNumber = this.model.recipientData.taxNumber;
    }
    if (!this.model.customerId) {
      this.model.customerId = this.model.recipientId;
    }
    if (!this.model.finalCustomerId) {
      this.model.finalCustomerId = this.model.recipientId;
    }
  }
  onAddFile(invoiceAttachment) {
    invoiceAttachment.attachment.internal = _.includes([InvoiceStatusCodes.Closed, InvoiceStatusCodes.Approved], this.model.statusId);
  }
  linkedInvoiceLabel(item) {
    return item.name;
  }
  baseCloneNavigate(action, cloneParams) {
    return this.router.navigate([`${this.parentRoute}/create/`], {
      state: {
        data: {
          action,
          cloneId: this.model.id,
          cloneParams
        }
      }
    });
  }
  cloneInvoice(command) {
    var _this11 = this;
    return _asyncToGenerator(function* () {
      const cloneId = history.state.data?.cloneId;
      const cloneParams = history.state.data?.cloneParams;
      const clonedInvoice = yield _this11.breezeViewService.handleCommand(command, {
        id: cloneId,
        serviceDate: new Date(),
        ...cloneParams
      });
      _this11.model = _this11.entityManager.createEntity(_this11.entityName, clonedInvoice);
      if (_.isNumber(_this11.model.payerId)) _this11.onPayerChange(_this11.model.payerId);
      if (_.isNumber(_this11.model.recipientId)) _this11.onRecipientChange(_this11.model.recipientId);
      _this11.stateMachine = new InvoiceStateMachine(_this11.model);
      _this11.activeTab = 0;
      _this11.isBusy = false;
      return _this11.model;
    })();
  }
  addChargeCandidates() {
    var _this12 = this;
    return _asyncToGenerator(function* () {
      const modalRef = _this12.breezeViewService.openModal(NmswChargeCandidatesModalComponent, {
        size: 'xl',
        windowClass: 'extra-large-modal'
      });
      modalRef.componentInstance.vtsVesselVisitId = _this12.model.vtsVesselVisitId;
      modalRef.componentInstance.invoice = {
        id: _this12.model.id,
        title: _this12.title
      };
      return modalRef.result.then(result => {
        if (!result) return;
        _this12.fetch();
      });
    })();
  }
  isTaxNumberCodeList() {
    return this.model.recipient?.code !== '0';
  }
  isRemoveInvoiceItemButtonVisible() {
    return !this.isInvoiceDisabled() && InvoiceTypeCodes.CreditNote !== this.model.typeId;
  }
  addVesselVisitItemsToInvoice() {
    const unitOfMeasurementsForServices = {
      [ServiceCodes.PortDues]: UnitOfMeasurementCodes.NetTonnage,
      [ServiceCodes.AnchorageDues]: UnitOfMeasurementCodes.LengthOverall,
      [ServiceCodes.WasteManagementFee]: UnitOfMeasurementCodes.GrossTonnage,
      [ServiceCodes.BerthageDues]: UnitOfMeasurementCodes.LengthOverall
    };
    const servicesForOtherUnitOfMeasurement = [ServiceCodes.SecurityFee, ServiceCodes.NewPermit, ServiceCodes.PermitExtension, ServiceCodes.PermitAmendment, ServiceCodes.PermitCancellation, ServiceCodes.PermitRevocation];
    history.state.data?.services?.forEach(el => {
      this.createItem('InvoiceItem', {
        taxId: TaxCodes.VAT0,
        unitOfMeasurementId: unitOfMeasurementsForServices[el.serviceId] ?? (servicesForOtherUnitOfMeasurement.includes(el.serviceId) ? UnitOfMeasurementCodes.Other : null),
        vesselVisitServiceId: el.id,
        serviceId: el.serviceId,
        description: el.description
      });
    });
    this.model.vesselVisitId = history.state.data?.vesselVisitId;
    this.tag.addInvoiceToVesselVisit = true;
  }
}
InvoiceViewComponent.ɵfac = function InvoiceViewComponent_Factory(t) {
  return new (t || InvoiceViewComponent)(i0.ɵɵdirectiveInject(i1.BreezeViewService), i0.ɵɵdirectiveInject(i2.UserService), i0.ɵɵdirectiveInject(i3.CqrsService), i0.ɵɵdirectiveInject(i4.InvoiceService), i0.ɵɵdirectiveInject(i5.RememberStateService));
};
InvoiceViewComponent.ɵcmp = /*@__PURE__*/i0.ɵɵdefineComponent({
  type: InvoiceViewComponent,
  selectors: [["app-pro-form-view"]],
  viewQuery: function InvoiceViewComponent_Query(rf, ctx) {
    if (rf & 1) {
      i0.ɵɵviewQuery(_c0, 5);
      i0.ɵɵviewQuery(_c1, 5);
      i0.ɵɵviewQuery(AppControlComponent, 5);
    }
    if (rf & 2) {
      let _t;
      i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.files = _t.first);
      i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.tabStrip = _t.first);
      i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.appControls = _t);
    }
  },
  features: [i0.ɵɵProvidersFeature([BreezeViewService]), i0.ɵɵInheritDefinitionFeature],
  decls: 14,
  vars: 1,
  consts: [[3, "isBusy"], ["tab0Content", ""], ["tab1Content", ""], ["tab2Content", ""], ["tab3Content", ""], ["tab4Content", ""], ["tab5Content", ""], [3, "items"], [3, "title", "breadcrumb"], [1, "card", "mt-1", "mb-4", "box-shadow", 2, "z-index", "98"], [1, "card-body", "p-2"], [1, "text-right"], [1, "pr-2"], ["class", "card card-border-top mb-3 shift-up", 4, "ngIf"], [1, "shift-up", 3, "tabSelect"], ["tabStrip", ""], [3, "title", "selected"], ["kendoTabContent", ""], [3, "title", "id", "selected"], [1, "card", "card-border-top", "mb-3", "shift-up"], [1, "card-body", "vessel-visit-info"], [3, "vtsVesselVisit", 4, "ngIf"], [3, "vesselVisit", 4, "ngIf"], [3, "vtsVesselVisit"], [3, "vesselVisit"], [4, "ngTemplateOutlet"], [1, "row"], [1, "col-2"], ["type", "codelist", "codelist", "Customer", "property", "payerId", 3, "label", "ngModel", "entity", "ngModelChange"], ["type", "codelist", "codelist", "User", "property", "issuedById", 3, "label", "isDisabled", "ngModel", "entity", "ngModelChange"], ["type", "codelist", "codelist", "User", "property", "approvedById", 3, "label", "isDisabled", "ngModel", "entity", "ngModelChange"], ["type", "codelist", "codelist", "User", "property", "createdById", 3, "label", "isDisabled", "ngModel", "entity", "ngModelChange"], ["property", "createdDate", 3, "label", "time", "isDisabled", "ngModel", "entity", "ngModelChange"], ["property", "serviceDate", 3, "label", "time", "isDisabled", "ngModel", "entity", "ngModelChange"], ["property", "customerOrderNumber", 3, "label", "isDisabled", "ngModel", "entity", "ngModelChange"], ["property", "issuedDate", 3, "label", "time", "isDisabled", "ngModel", "entity", "ngModelChange"], ["property", "approvedDate", 3, "label", "time", "isDisabled", "ngModel", "entity", "ngModelChange"], ["type", "codelist", "codelist", "User", "property", "lastModifiedById", 3, "label", "isDisabled", "ngModel", "entity", "ngModelChange"], ["property", "lastModifiedDate", 3, "label", "time", "isDisabled", "ngModel", "entity", "ngModelChange"], ["property", "archivedDate", 3, "label", "time", "isDisabled", "ngModel", "entity", "ngModelChange"], [1, "col-3"], ["property", "addressLine1", 3, "label", "isDisabled", "ngModel", "entity", "ngModelChange", 4, "ngIf", "ngIfElse"], ["payerAddress1", ""], ["property", "addressLine2", 3, "label", "isDisabled", "ngModel", "entity", "ngModelChange", 4, "ngIf", "ngIfElse"], ["payerAddress2", ""], ["property", "city", 3, "label", "isDisabled", "ngModel", "entity", "ngModelChange", 4, "ngIf", "ngIfElse"], ["city2", ""], ["type", "codelist", "codelist", "PostOffice", "property", "postOfficeId", 3, "label", "isDisabled", "ngModel", "entity", "ngModelChange"], ["type", "codelist", "codelist", "Country", "property", "countryId", 3, "label", "isDisabled", "ngModel", "entity", "ngModelChange"], ["property", "taxNumber", 3, "label", "isDisabled", "ngModel", "entity", "ngModelChange"], ["class", "col", 4, "ngIf"], ["type", "codelist", "codelist", "InvoiceStatus", "property", "statusId", 3, "label", "isDisabled", "ngModel", "entity", "ngModelChange"], ["type", "codelist", "codelist", "InvoiceType", "property", "typeId", 3, "label", "isDisabled", "ngModel", "entity", "ngModelChange"], ["property", "invoiceNumber", 3, "label", "isDisabled", "ngModel", "entity", "ngModelChange"], ["type", "codelist", "codelist", "Invoice", "property", "linkedInvoiceId", 3, "label", "selectLabel", "isDisabled", "ngModel", "entity", "ngModelChange"], [1, "col"], [1, "mb-3"], ["property", "electronicInvoice", 3, "label", "isDisabled", "ngModel", "entity", "ngModelChange"], [3, "items", "isDisabled"], ["property", "addressLine1", 3, "label", "isDisabled", "ngModel", "entity", "ngModelChange"], [3, "label", "isDisabled"], ["property", "addressLine2", 3, "label", "isDisabled", "ngModel", "entity", "ngModelChange"], ["property", "city", 3, "label", "isDisabled", "ngModel", "entity", "ngModelChange"], ["type", "codelist", "property", "taxNumber", 3, "label", "options", "isDisabled", "ngModel", "entity", "ngModelChange"], [1, "row", "mb-3"], ["type", "codelist", "property", "berthId", 3, "label", "fetch", "fetchOnOpen", "isDisabled", "ngModel", "entity", "ngModelChange"], [3, "items", "automatic", "isCreditNote", "editMode", "totalsUpdated"], ["type", "file", "property", "attachments", 3, "multi", "editMode", "isInternalDisabled", "allowToEditFile", "allowToDeleteFile", "ngModel", "entity", "ngModelChange", "addFile"], ["files", ""], [3, "items", "editMode"], [3, "invoiceId"]],
  template: function InvoiceViewComponent_Template(rf, ctx) {
    if (rf & 1) {
      i0.ɵɵelementStart(0, "app-loader", 0);
      i0.ɵɵtemplate(1, InvoiceViewComponent_ng_template_1_Template, 47, 53, "ng-template");
      i0.ɵɵelementEnd();
      i0.ɵɵtemplate(2, InvoiceViewComponent_ng_template_2_Template, 74, 136, "ng-template", null, 1, i0.ɵɵtemplateRefExtractor);
      i0.ɵɵtemplate(4, InvoiceViewComponent_ng_template_4_Template, 4, 8, "ng-template", null, 2, i0.ɵɵtemplateRefExtractor);
      i0.ɵɵtemplate(6, InvoiceViewComponent_ng_template_6_Template, 3, 4, "ng-template", null, 3, i0.ɵɵtemplateRefExtractor);
      i0.ɵɵtemplate(8, InvoiceViewComponent_ng_template_8_Template, 4, 7, "ng-template", null, 4, i0.ɵɵtemplateRefExtractor);
      i0.ɵɵtemplate(10, InvoiceViewComponent_ng_template_10_Template, 1, 2, "ng-template", null, 5, i0.ɵɵtemplateRefExtractor);
      i0.ɵɵtemplate(12, InvoiceViewComponent_ng_template_12_Template, 1, 1, "ng-template", null, 6, i0.ɵɵtemplateRefExtractor);
    }
    if (rf & 2) {
      i0.ɵɵproperty("isBusy", ctx.isBusy || !ctx.model);
    }
  },
  dependencies: [i6.NgIf, i6.NgTemplateOutlet, i7.NgControlStatus, i7.NgModel, i8.TabStripComponent, i8.TabStripTabComponent, i8.TabContentDirective, i9.ActionBarComponent, i10.AppControlComponent, i11.LoaderComponent, i12.ContentHeaderComponent, i13.NoteListComponent, i14.VesselVisitViewComponent, i15.NmswVesselVisitViewComponent, i16.InvoiceEmailRecipientComponent, i17.InvoiceChangeListComponent, i18.InvoiceItemListComponent, i19.TranslatePipe, i20.NumberPipe],
  styles: ["input[type=radio][_ngcontent-%COMP%] {\n  margin-right: 8px;\n}\n\n.vessel-visit-info[_ngcontent-%COMP%] {\n  height: 466px;\n  overflow: scroll;\n  overflow-x: hidden;\n}\n\n.shift-up[_ngcontent-%COMP%] {\n  position: relative;\n  top: -29px;\n}\n/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIndlYnBhY2s6Ly8uL3NyYy9hcHAvaW52b2ljZS9jb21wb25lbnRzL2ludm9pY2Utdmlldy9pbnZvaWNlLXZpZXcuY29tcG9uZW50LnNjc3MiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUE7RUFDSSxpQkFBQTtBQUNKOztBQUVBO0VBQ0ksYUFBQTtFQUNBLGdCQUFBO0VBQ0Esa0JBQUE7QUFDSjs7QUFFQTtFQUNJLGtCQUFBO0VBQ0EsVUFBQTtBQUNKIiwic291cmNlc0NvbnRlbnQiOlsiaW5wdXRbdHlwZT0ncmFkaW8nXSB7XHJcbiAgICBtYXJnaW4tcmlnaHQ6IDhweDtcclxufVxyXG5cclxuLnZlc3NlbC12aXNpdC1pbmZvIHtcclxuICAgIGhlaWdodDogNDY2cHg7XHJcbiAgICBvdmVyZmxvdzogc2Nyb2xsO1xyXG4gICAgb3ZlcmZsb3cteDogaGlkZGVuO1xyXG59XHJcblxyXG4uc2hpZnQtdXAge1xyXG4gICAgcG9zaXRpb246IHJlbGF0aXZlO1xyXG4gICAgdG9wOiAtMjlweDtcclxufVxyXG4iXSwic291cmNlUm9vdCI6IiJ9 */"]
});